export const All_USER_METRICS_FUNCTIONS = {
    FetchUserMetrics: "AllUserMetricsFunctions-fetchUserMetrics",
    UpdateTimeSpent: "AllUserMetricsFunctions-updateTimeSpent",
    UpdateFocusTime: "AllUserMetricsFunctions-updateFocusTime",
};

export const CANNY_FUNCTIONS = {
    GenerateCannyToken: "CannyFunctions-generateCannyToken",
};

export const CLIENT_ERROR_FUNCTIONS = {
    LogClientError: "ClientErrorFunctions-logClientError",
};

export const CRISP_CHAT_FUNCTIONS = {
    SendUpgradeQuestion: "CrispChatFunctions-sendUpgradeQuestion",
};

export const LIVE_STREAMING_FUNCTIONS = {
    GetGuestToken: "LiveStreamingFunctions-getGuestToken",
    GetHostToken: "LiveStreamingFunctions-getHostToken",
};

export const NOTES_WIDGET_FUNCTIONS = {
    UpdateNote: "NotesWidgetFunctions-updateNote",
};

export const POMODORO_WIDGET_FUNCTIONS = {
    FetchProAlarmSounds: "PomodoroWidgetFunctions-fetchProAlarmSounds",
    UpdateSelectedAlarmSrc: "PomodoroWidgetFunctions-updateSelectedAlarmSrc",
    StartGroupPomodoroWorkflow: "PomodoroWidgetFunctions-startGroupPomodoroWorkflow",
    StopGroupPomodoroWorkflow: "PomodoroWidgetFunctions-stopGroupPomodoroWorkflow",
};

export const ROOM_CHAT_FUNCTIONS = {
    SendMessage: "RoomChatFunctions-sendMessage",
    ReportMessage: "RoomChatFunctions-reportMessage",
    DeleteAllMessages: "RoomChatFunctions-deleteAllMessages",
    DeleteMessage: "RoomChatFunctions-deleteMessage",
};

export const ROOMS_FUNCTIONS = {
    InitUserRoomsData: "RoomsFunctions-initUserRoomsData",
    CreateRoom: "RoomsFunctions-createRoom",
    GenerateTwilioRoomAccessToken: "RoomsFunctions-generateTwilioRoomAccessToken",
    OnVideoCallParticipantChange: "RoomsFunctions-onVideoCallParticipantChange",
    FetchRoomData: "RoomsFunctions-fetchRoomData",
    ToggleRoomLocked: "RoomsFunctions-toggleRoomLocked",
    UpdateRoomName: "RoomsFunctions-updateRoomName",
    AddUserToMemberList: "RoomsFunctions-addUserToMemberList",
    ToggleMemberMutedStatus: "RoomsFunctions-toggleMemberMutedStatus",
    ToggleMemberBannedStatus: "RoomsFunctions-toggleMemberBannedStatus",
};

export const SOUNDBOARD_WIDGET_FUNCTIONS = {
    FetchPremiumSounds: "SoundboardWidgetFunctions-fetchPremiumSounds",
    SaveSoundsOrder: "SoundboardWidgetFunctions-saveSoundsOrder",
};

export const STRIPE_FUNCTIONS = {
    GetSubscriptionPriceInfo: "StripeFunctions-getSubscriptionPriceInfo",
    GetSubscriptionTrialDuration: "StripeFunctions-getSubscriptionTrialDuration",
    CheckoutSessionProSub: "StripeFunctions-checkoutSessionProSub",
    OpenBillingPortal: "StripeFunctions-openBillingPortal",
    RequestProSubscriptionCancellation: "StripeFunctions-requestProSubscriptionCancellation",
};

export const USER_METRICS_FUNCTIONS = {
    UpdateUserStreak: "UserMetricsFunctions-updateUserStreak",
};

export const WIDGET_TAB_FUNCTIONS = {
    // Functions for Notes
    SelectWidgetTab: "WidgetTabFunctions-selectWidgetTab",
    EditWidgetTabName: "WidgetTabFunctions-editWidgetTabName",
    DeleteWidgetTab: "WidgetTabFunctions-deleteWidgetTab",
    CreateWidgetTab: "WidgetTabFunctions-createWidgetTab",
};
